import { render, staticRenderFns } from "./cover.vue?vue&type=template&id=424b6b0a&scoped=true"
import script from "./cover.vue?vue&type=script&lang=js"
export * from "./cover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b6b0a",
  null
  
)

export default component.exports